export const personalPlanMonthParentResult = {
  Model: {
    class: 'plan',
    properties: {
      tenantId: '3',
      responseType: 'GroupByResource',
      viewOptions: {
        'grouped-by': 'group-by-resource',
        'reporting-types': 'utilization',
        'period-types': 'month',
        'unit-types': 'hours',
        'period-starts-at': '2025-03-27',
        'period-ends-at': '2025-08-27',
      },
      periods: [
        {
          startsAt: '2025-03-01T00:00:00',
          endsAt: '2025-03-31T00:00:00',
          type: 'Month',
          identifier: '2025Mar',
        },
        {
          startsAt: '2025-04-01T00:00:00',
          endsAt: '2025-04-30T00:00:00',
          type: 'Month',
          identifier: '2025Apr',
        },
        {
          startsAt: '2025-05-01T00:00:00',
          endsAt: '2025-05-31T00:00:00',
          type: 'Month',
          identifier: '2025May',
        },
        {
          startsAt: '2025-06-01T00:00:00',
          endsAt: '2025-06-30T00:00:00',
          type: 'Month',
          identifier: '2025Jun',
        },
        {
          startsAt: '2025-07-01T00:00:00',
          endsAt: '2025-07-31T00:00:00',
          type: 'Month',
          identifier: '2025Jul',
        },
      ],
      children: [
        {
          StartsAt: '2013-01-02T00:00:00',
          EndsAt: '2014-01-02T00:00:00',
          hierarchyType: 'workitem',
          values: {
            '2025Mar': {
              displayValue: 18.0,
              value: 18.0,
              heatmapCode: '',
              editable: true,
            },
            '2025Apr': {
              displayValue: 40.0,
              value: 40.0,
              heatmapCode: '',
              editable: true,
            },
            '2025May': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025Jun': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025Jul': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
          },
          Budget: 0.0,
          TotalBooked: 58.0,
          TotalActualWorkload: 0.0,
          TotalEAC: 58.0,
          NotPlanned: -58.0,
          PositiveUnplannedHours: 0,
          NegativeUnplannedHours: -58.0,
          total: {
            displayValue: 58.0,
            value: 58.0,
          },
          canExpand: true,
          editable: false,
          canAssign: false,
          canDelete: false,
          resourceId: '399188812783157248',
          resourceSourceReferenceId: 62,
          resourceType: 'Employee',
          workItemId: '399194234395033601',
          workItemSourceReferenceId: '1462',
          workItemType: 'Project',
          hasChildWithEndDateOnTodayOrAfter: false,
          rootParentName: 'Lee 1234567890 Jenn Woei 1234567890',
          id: '399194234395033601',
          name: '_TIM - Management (P09.0249)',
          sourceReferenceId: '1462',
          tenantId: '3',
          type: 'Project',
          pathToParent: '/',
          sortOrder: 0,
          level: 1,
          sortablePath: '/_TIM - Management',
          isActive: false,
          startAt: '0001-01-01T00:00:00',
          endAt: '0001-01-01T00:00:00',
          status: 'InProgress',
          lastUserSetIsActive: false,
        },
        {
          StartsAt: '2017-05-05T00:00:00',
          EndsAt: '2017-05-19T00:00:00',
          hierarchyType: 'workitem',
          values: {
            '2025Mar': {
              displayValue: 7.2,
              value: 7.2,
              heatmapCode: '',
              editable: true,
            },
            '2025Apr': {
              displayValue: 32.0,
              value: 32.0,
              heatmapCode: '',
              editable: true,
            },
            '2025May': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025Jun': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025Jul': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
          },
          Budget: 360.0,
          TotalBooked: 39.2,
          TotalActualWorkload: 0.0,
          TotalEAC: 39.2,
          NotPlanned: 320.8,
          PositiveUnplannedHours: 320.8,
          NegativeUnplannedHours: 0,
          total: {
            displayValue: 39.2,
            value: 39.2,
          },
          canExpand: true,
          editable: false,
          canAssign: false,
          canDelete: false,
          resourceId: '399188812783157248',
          resourceSourceReferenceId: 62,
          resourceType: 'Employee',
          workItemId: '399194016270254081',
          workItemSourceReferenceId: '12235',
          workItemType: 'Project',
          hasChildWithEndDateOnTodayOrAfter: false,
          rootParentName: 'Lee 1234567890 Jenn Woei 1234567890',
          id: '399194016270254081',
          name: '_TIMJenm006EURTE (P17.0096)',
          sourceReferenceId: '12235',
          tenantId: '3',
          type: 'Project',
          pathToParent: '/',
          sortOrder: 0,
          level: 1,
          sortablePath: '/_TIMJenm006EURTE',
          isActive: false,
          startAt: '0001-01-01T00:00:00',
          endAt: '0001-01-01T00:00:00',
          status: 'InProgress',
          lastUserSetIsActive: false,
        },
        {
          StartsAt: '2017-08-30T00:00:00',
          EndsAt: '2025-11-30T00:00:00',
          hierarchyType: 'workitem',
          values: {
            '2025Mar': {
              displayValue: 8.0,
              value: 8.0,
              heatmapCode: '',
              editable: true,
            },
            '2025Apr': {
              displayValue: 10.0,
              value: 10.0,
              heatmapCode: '',
              editable: true,
            },
            '2025May': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025Jun': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
            '2025Jul': {
              displayValue: 0,
              value: 0,
              heatmapCode: '',
              editable: true,
            },
          },
          Budget: 300.0,
          TotalBooked: 18.0,
          TotalActualWorkload: 250.0,
          TotalEAC: 268.0,
          NotPlanned: 32.0,
          PositiveUnplannedHours: 32.0,
          NegativeUnplannedHours: 0,
          total: {
            displayValue: 18.0,
            value: 18.0,
          },
          canExpand: true,
          editable: false,
          canAssign: false,
          canDelete: false,
          resourceId: '399188812783157248',
          resourceSourceReferenceId: 62,
          resourceType: 'Employee',
          workItemId: '399194052248993793',
          workItemSourceReferenceId: '14351',
          workItemType: 'Project',
          hasChildWithEndDateOnTodayOrAfter: true,
          rootParentName: 'Lee 1234567890 Jenn Woei 1234567890',
          id: '399194052248993793',
          name: '_TIMJenm038EUR (P17.0208)',
          sourceReferenceId: '14351',
          tenantId: '3',
          type: 'Project',
          pathToParent: '/',
          sortOrder: 0,
          level: 1,
          sortablePath: '/_TIMJenm038EUR',
          isActive: false,
          startAt: '0001-01-01T00:00:00',
          endAt: '0001-01-01T00:00:00',
          status: 'InProgress',
          lastUserSetIsActive: false,
        },
      ],
    },
    links: [
      {
        href: 'https://localhost:7140/plan/partialgroupbyemployee?periodstartsat=2025-03-27&periodendsat=2025-08-27&periodtypes=month&unittypes=hours&reportingtypes=utilization&showprojectno=true&showtaskno=true&requesthavefilters=true&onlyincludeplanned=true',
        rel: 'self',
      },
    ],
  },
  DeterministicHash: 333436046,
  StatusCode: 200,
};
